import { type GridAutosizeOptions, type GridColDef, type GridSortModel } from '@mui/x-data-grid-pro'
import { formatToLocalMilliTimestampFromUTCString } from '../../../../utils/time-utils'

export const LIVE_ORDERS_COL_DEF: GridColDef[] = [
  {
    field: 'createTime',
    headerName: 'Create Time',
    type: 'string',
    minWidth: 120,
    valueFormatter: (value) => formatToLocalMilliTimestampFromUTCString(value),
  },
  {
    field: 'lastUpdateTime',
    headerName: 'Last Update Time',
    type: 'string',
    minWidth: 120,
    valueFormatter: (value) => formatToLocalMilliTimestampFromUTCString(value),
  },
  {
    field: 'state',
    headerName: 'State',
    type: 'string',
    minWidth: 100
  },
  {
    field: 'orderId',
    headerName: 'Order Id',
    type: 'string',
    minWidth: 70
  },
  {
    field: 'symbol',
    headerName: 'Symbol',
    type: 'string',
    minWidth: 160
  },
  {
    field: 'productAlias',
    headerName: 'Product Alias',
    type: 'string',
    minWidth: 100
  },
  {
    field: 'side',
    headerName: 'Side',
    type: 'string',
    minWidth: 60
  },
  {
    field: 'price',
    headerName: 'Price',
    type: 'string',
    align: 'right',
    minWidth: 80
  },
  {
    field: 'size',
    headerName: 'Size',
    type: 'string',
    align: 'right',
    minWidth: 70
  },
  {
    field: 'tag',
    headerName: 'Tag',
    type: 'string',
    minWidth: 70
  },
  {
    field: 'account',
    headerName: 'Account',
    type: 'string',
    minWidth: 70
  },
  {
    field: 'exchange',
    headerName: 'Exchange',
    type: 'string',
    minWidth: 70
  },
]

export const LIVE_ORDERS_AUTOSIZE_OPTIONS: GridAutosizeOptions = {
  columns: Array.from(LIVE_ORDERS_COL_DEF, item => item?.field),
  includeHeaders: true,
  includeOutliers: true,
}

export const LIVE_ORDERS_SORT_MODEL: GridSortModel = [
  { field: 'lastUpdateTime', sort: 'desc' },
  { field: 'createTime', sort: 'desc' },
]
